import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import Form from "../../../components/common/form/Form";
import {  formatValueAsDateAndTime } from "../../../helpers/utils/DateUtils";
import Modal from "../../../components/common/form/Modal";
import SelectField from "../../../components/common/form/SelectField";
import { createOptionListForSelectTag } from "../../../helpers/utils/Utils";
import TextAreaField from "../../../components/common/form/TextAreaField";
import InputField from "../../../components/common/form/InputField";
import ButtonTray from "../../../components/common/form/ButtonTray";
import { useEndFollowUpServiceMutation, useLazyGetFollowUpTypeByTenantQuery, useStartProductFollowUpActionMutation } from "../../tenantAdmin/followUpTypes/followUpTypesApi";
import { handleRTKQuery } from "../../../helpers/utils/RtkQueryUtils";
import { useGetOrderByOrderIdAndTypeQuery } from "../ordersApi";
import { skipToken } from "@reduxjs/toolkit/query";

interface Props {
    show: boolean;
    setShow: (value: boolean) => void;
    isHoa?: boolean;
    btnName?: string;
    currentProduct?: any;
    orderId?: string;
}

const AddFollowUpForProduct = ({
    show,
    setShow,
    isHoa = false,
    btnName,
    currentProduct,
    orderId,
}: Props) => {

    const [disable, setDisable] = useState(false);
    const [message, setMessage] = useState(currentProduct.followUp?.followUpMessage || "");
    const [type, setType] = useState<{ label: string; value: any } | null>(
        currentProduct.followUpTypeDTO?.name
            ? { label: currentProduct.followUpTypeDTO.name, value: currentProduct.followUpTypeDTO.id }
            : null
    );
    const {
        data: orderDetail,
    } = useGetOrderByOrderIdAndTypeQuery({ orderId: orderId , orderType: 'OTHER' });

    const [followUpData , followUpDataApi] = useLazyGetFollowUpTypeByTenantQuery();

    useEffect(()=>{

        if (orderDetail){
            followUpData(orderDetail?.tenant);
        }
    },[orderDetail]);

    const [createApi, createApiResp] = useStartProductFollowUpActionMutation();
    const [updateApi, updateApiRes] = useEndFollowUpServiceMutation();


    useEffect(() => {
        setMessage(currentProduct.followUp?.followUpMessage || "");
        setType(currentProduct.followUpTypeDTO?.name
            ? { label: currentProduct.followUpTypeDTO.name, value: currentProduct.followUpTypeDTO.id }
            : null
        );
    }, [currentProduct]);


    function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        setDisable(true);
        const obj = {
            followUpTypeId: type?.value,
            followUpMessage: message
        };
        handleRTKQuery(
            () => createApi({ requestBody: obj, productId: currentProduct?.id }),
            () => setShow(false)
        );

    }

    function handleCancelSubmit(e: React.MouseEvent<HTMLButtonElement>) {
        e.preventDefault();
        setType(null);
        updateApi(currentProduct?.id)
        setShow(false)
    }

    const handleOnChange = (e: ChangeEvent<HTMLInputElement> | { name: string; value: any, }) => {
        const { name, value } = "target" in e ? e.target : e;
        setType(value)
    }

    return (
        <Modal
            title={"Follow Up Detail"}
            show={show}
            setShow={setShow}
            className={"w-2/5 bg-text-0 text-surface-0"}
            hoa={isHoa}
            fields={
                <>
                    <Form onSubmit={handleSubmit} fields={
                        <div className="modal-body">
                            <div className="form-group row">
                                <SelectField
                                    label="Type"
                                    value={type || null}
                                    placeholder="Select type..."
                                    options={createOptionListForSelectTag(followUpDataApi?.data, "name", "id")}
                                    onChange={(selectedOption) => {
                                        handleOnChange({ name: "type", value: selectedOption })
                                    }}
                                    required={true}
                                />
                            </div>
                            <TextAreaField
                                label="Message"
                                name="message"
                                placeholder="Enter Message..."
                                value={message || ""}
                                className="mb-2 text-surface-2"
                                onChange={(e) => setMessage(e.target.value)}
                            />




                            {currentProduct.followUp?.followUpTypeId && (
                                <>

                                    <InputField
                                        label="Modified By"
                                        value={currentProduct.followUp.followUpBy || ""}
                                        type="text"
                                        disabled
                                        className="mb-2"
                                    />
                                    <InputField
                                        label="Modified Date"
                                        value={String(formatValueAsDateAndTime(currentProduct.followUp.followUpAdded))}
                                        type="text"
                                        disabled
                                        className="mb-2"
                                    />
                                </>
                            )}

                            <div className="mt-4 border-t border-t-surface-5 flex justify-end">
                                <ButtonTray
                                    buttons={[
                                        {
                                            buttonProps: {
                                                btnText: "Cancel",
                                                onClick: () => setShow(false),
                                                type: "cancel",
                                                className: "bg-[red]"
                                            },
                                            buttonType: "button"
                                        },
                                        {
                                            buttonProps: {
                                                btnText: btnName,
                                                type: "submit",
                                                isLoading: createApiResp.isLoading || updateApiRes.isLoading,
                                                isDisabled: disable,
                                                isHoa: isHoa
                                            },
                                            buttonType: "button"
                                        },
                                        currentProduct.followUp?.followUpTypeId && {
                                            buttonProps: {
                                                btnText: "Close",
                                                onClick: handleCancelSubmit,
                                                type: "close",
                                                className: "bg-[red]"
                                            },
                                            buttonType: "button"
                                        }
                                    ]}
                                    align={"start"}
                                    gap={2}
                                />
                            </div>


                        </div>

                    } />
                </>
            } />

    );
};

export default AddFollowUpForProduct;
